module.exports = __webpack_public_path__ + "img/qkgw.61e4d55e.png";